import React from 'react';
import StockConversionForm from './StockConversionForm';
import { useParams } from 'react-router-dom';

const EditStockConversionPage = () => {
    const { id } = useParams();
    
    return id ? <StockConversionForm formType="edit" currentConversionId={id} /> : <div>Loading...</div>;
};

export default EditStockConversionPage;